<template>
    <div>
        <div class="text-subtitle-1 text-medium-emphasis">{{ label }}</div>
        <v-combobox
            class="inputfield"
            v-model:model-value="modelValue"
            item-text="bezeichnung"
            item-value="bezeichnung"
            :items="anredenBezeichnungen"
            :dense="dense"
            :loading="loading"
            hide-selected
        ></v-combobox>
    </div>
</template>

<script setup lang="ts">
import { AnredeCollection } from '@/models/Anrede'
import { onMounted, ref, type Ref } from 'vue'

const modelValue = defineModel<string | null>('modelValue')

defineProps({
    dense: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        default: '',
    },
})
const loading = ref(false)
const anreden = new AnredeCollection()
const anredenBezeichnungen: Ref<string[]> = ref([])

onMounted(() => {
    load()
})

async function load() {
    loading.value = true
    try {
        await anreden.query()
        if (anreden) {
            anredenBezeichnungen.value = anreden.getModels().map((a) => a.bezeichnung || '')
        }
    } finally {
        loading.value = false
    }
}
</script>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
</style>
